export const LARGE_DATASET_THRESHOLDS = {
  warnRows: 5000,
  auditSampleRows: 10000,
}

export function getLargeDatasetInfo(rows = []) {
  const rowCount = Array.isArray(rows) ? rows.length : 0
  const isLarge = rowCount >= LARGE_DATASET_THRESHOLDS.warnRows
  const auditSampleSize = Math.min(rowCount, LARGE_DATASET_THRESHOLDS.auditSampleRows)

  return {
    rowCount,
    isLarge,
    auditSampleSize,
    auditSampled: rowCount > auditSampleSize,
  }
}

export function getAuditRows(rows = []) {
  const { auditSampleSize } = getLargeDatasetInfo(rows)
  return Array.isArray(rows) ? rows.slice(0, auditSampleSize) : []
}

export function getSampledRows(rows = [], maxRows) {
  if (!Array.isArray(rows) || rows.length === 0) return []
  if (!maxRows || rows.length <= maxRows) return rows

  const stride = rows.length / maxRows
  const sampled = []

  for (let index = 0; index < maxRows; index += 1) {
    sampled.push(rows[Math.floor(index * stride)])
  }

  return sampled
}
